import { render, staticRenderFns } from "./SSelectPlagues.vue?vue&type=template&id=04854147"
import script from "./SSelectPlagues.vue?vue&type=script&lang=js"
export * from "./SSelectPlagues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports